import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import * as DataList from 'components/DataList';
import { observer, inject } from 'mobx-react';
import Page from 'components/Page';
import ClientProfileCard, { ClientPageSkeleton } from 'components/Client/ProfileCard';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding: 5px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'clientStore', 'viewStore') @observer
class ClientsShowPage extends Component {

  get canRender() {
    let {
      clientStore: {
        client: {
          isLoading,
          isError,
          object
        }
      }
    } = this.props;
    return (object && object.id);
  }

  componentWillUnmount() {
    let {
      clientStore
    } = this.props;
    clientStore.clearSelectedClient();
  }

  retry = () => {
    const { clientStore, viewStore } = this.props;
    const uuid = window.location.pathname.split('/').filter(Boolean).pop();
    clientStore.loadClient({ uuid });
    clientStore.loadAnalytics({ uuid });
    viewStore.clientShow({ uuid });
  };

  // A client that doesn't exist (deleted, or a wrong link) gets a way back;
  // anything else (offline, server error) gets Try again.
  renderError() {
    const { clientStore: { client }, viewStore } = this.props;
    const missing = client.errorStatus === 404 || client.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to clients', icon: 'arrow-left', onClick: () => viewStore.clients() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="person"
            title="This client isn't here"
            message="It may have been deleted, or the link may be wrong. Find the client in your list instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The client couldn't be loaded"
            message={offline
              ? "You're offline. Reconnect, then try again."
              : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  updateSelectedResource = (resource) => {
    let {
      viewStore,
      clientStore: {
        client: {
          object
        }
      }
    } = this.props;
    viewStore.clientShowSearch.resource = resource;
    // Keeps the client's name in the breadcrumb (clientViewSearch dropped it).
    viewStore.clientShow({ uuid: object.attributes.id }, object.attributes.name);
  }

  render() {
    let content, title;
    let {
      viewStore,
      clientStore: {
        client: {
          isLoading,
          isError,
          object
        }
      }
    } = this.props;
    if (isLoading && !isError && object && !object.id) {
      title = 'Loading..';
      content = <ClientPageSkeleton />;
    }
    if (isError && !isLoading && object && !object.id) {
      title = `${this.props.clientStore.client.errorStatus === 404 ? 'Client not found' : "Couldn't load client"} | Field Nexus`;
      content = this.renderError();
    }
    if (this.canRender) {
      title = `${object.attributes.name} | Field Nexus`;
      content = <ClientProfileCard 
        client={object}
        selectedResource={viewStore.clientShowSearch.resource}
        onResourceChange={this.updateSelectedResource.bind(this)} 
      />
    }
    return (
      <div>
        {
          <Helmet>
            <title>{title}</title>
          </Helmet>
        }
        <PageWrapGray>
        <Page>
          {content}
        </Page>
        </PageWrapGray>
      </div>
    )
  }

};

export default ClientsShowPage;